// extracted by mini-css-extract-plugin
export default {"CreateIssueContainer":"CreateIssue-module__CreateIssueContainer--Laikr"};